import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class ProjectTypesService{
  private listItem: any[] = [];


  public setListItem(list: any[]): void {
    this.listItem = list;
  }

  public getListItem(): any[] {
    return this.listItem;
  }

}
